import { useCallback } from 'react';
import { useNavigate } from 'react-router-dom';

import {
  MembershipStateChangeFragment,
  MembershipActivityFragment,
  MembershipActivityTypename,
} from '@occc/graphql';
import { routeCreator } from '@occc-app/routes/Member/utils';

import Activity from './Activity';

type ActivityContainerProps = {
  memberId: string;
  stateChanges: MembershipStateChangeFragment[];
};

const ActivityContainer = (props: ActivityContainerProps) => {
  const navigate = useNavigate();
  const { memberId, stateChanges } = props;

  const onMembershipActivityClick = useCallback(
    (transaction: MembershipActivityFragment) => {
      if (transaction.type === MembershipActivityTypename.PointChange) {
        navigate(routeCreator.pointChange(transaction.id));
      } else {
        navigate(routeCreator.transaction(transaction.id));
      }
    },
    [navigate],
  );

  return (
    <Activity
      memberId={memberId}
      stateChanges={stateChanges}
      onMembershipActivityClick={onMembershipActivityClick}
    />
  );
};

export default ActivityContainer;
